import { Box, Flex, Text } from "@chakra-ui/layout";
import { ContextMenu, ContextMenuTrigger, MenuItem } from "react-contextmenu";

import DataGrid, { RowRendererProps, Row as GridRow } from "react-data-grid";
import { Popover } from "antd";
import { IoMdAlert } from "react-icons/io";
import type { Column } from "react-data-grid";
import colors from "resources/theme/colors";

function RowRenderer<T>(props: RowRendererProps<T>) {
  return (
    <ContextMenuTrigger
      id="grid-context-menu"
      collect={() => ({ rowIdx: props.rowIdx })}
    >
      <GridRow {...props} />
    </ContextMenuTrigger>
  );
}

export interface TabelaImportacaoProps<T> {
  setData: (items: T[]) => any;
  data: T[];
  onRowDelete: (
    e: React.MouseEvent<HTMLDivElement>,
    props: { rowIdx: number }
  ) => any;
  onRowInsertAbove: (
    e: React.MouseEvent<HTMLDivElement>,
    props: { rowIdx: number }
  ) => any;
  onRowInsertBelow: (
    e: React.MouseEvent<HTMLDivElement>,
    props: { rowIdx: number }
  ) => any;
  columns: readonly Column<T>[];
}

function TabelaImportacao<T>({
  setData,
  data,
  onRowDelete,
  onRowInsertAbove,
  onRowInsertBelow,
  columns,
}: TabelaImportacaoProps<T>) {
  return (
    <Box mt="32px" width="100%" overflowX="auto" minH="350px">
      <DataGrid
        rowRenderer={RowRenderer}
        cellNavigationMode="CHANGE_ROW"
        onRowsChange={setData}
        columns={columns.map((item) => ({
          ...item,
          formatter: ({ row, column }: any) => {
            const errors = row.errors ? row.errors[column.key] ?? [] : [];

            return (
              <Flex
                bg={errors.length ? "red.100" : undefined}
                color={errors.length ? colors.black700 : undefined}
                mx="-16px"
                h="35px"
                px="16px"
              >
                {errors.length ? (
                  <Flex w="20px" pos="relative" mr="4px" alignItems="center">
                    <Popover
                      title="Erros"
                      content={
                        <Box>
                          {errors.map((err: string) => (
                            <p>{err}</p>
                          ))}
                        </Box>
                      }
                    >
                      <IoMdAlert color="red" />
                    </Popover>
                  </Flex>
                ) : null}
                <Flex flex={1} fontWeight={errors.length ? "bold" : undefined}>
                  {row[column.key]?.toString()}
                </Flex>
              </Flex>
            );
          },
        }))}
        rows={data}
        style={{
          height: "50vh",
        }}
        defaultColumnOptions={{
          resizable: true,
        }}
      />
      <ContextMenu
        id="grid-context-menu"
        style={{
          backgroundColor: "white",
          borderRadius: 8,
          boxShadow: "0 2px 10px 10px rgba(0,0,0,0.25)",
        }}
      >
        <MenuItem onClick={onRowInsertBelow}>
          <Text
            roundedTop={8}
            cursor="pointer"
            w="100%"
            px="10px"
            _hover={{
              backgroundColor: colors.black50,
            }}
            py={1}
          >
            + Inserir linha depois
          </Text>
        </MenuItem>
        <MenuItem onClick={onRowInsertAbove}>
          <Text
            cursor="pointer"
            w="100%"
            px="10px"
            _hover={{
              backgroundColor: colors.black50,
            }}
            py={1}
          >
            + Inserir linha antes
          </Text>
        </MenuItem>
        <MenuItem onClick={onRowDelete}>
          <Text
            roundedBottom={8}
            cursor="pointer"
            w="100%"
            px="10px"
            _hover={{
              backgroundColor: colors.black50,
            }}
            py={1}
          >
            - Excluir linha
          </Text>
        </MenuItem>
      </ContextMenu>
    </Box>
  );
}

export default TabelaImportacao;
